module.exports = __webpack_public_path__ + "img/benefit01.a1a1e7d2.png";